import React from "react";
import {Row, Col, Form, Input, Select} from 'antd';
import { InputNumero } from "../../../Numeros/input-numero";
import { useDispatch , useSelector} from "react-redux";
import {  atualizaProduto } from "../store/cadastro-produto.reducer";
import { newProduto } from "../store/produto.domain";


const { TextArea } = Input;
const {Option} = Select;

const TabECommerce = ({dataTab})=> {

    const dispatch = useDispatch();
    
    const {produto:dadosProduto} = useSelector(state => state.produto)
    const produto = newProduto(dadosProduto);
    const changeFatorCorrecaoUnidadeEcommerceHandler = ({floatValue:fatorCorrecaoUnidadeEcommerce})=>{
        produto.fillFatorCorrecaoEcommerce(fatorCorrecaoUnidadeEcommerce)
        dispatch(atualizaProduto(produto.toPlainJson()));
    }
    
    return (
        <Row gutter={[16, 16]}>
           
           <Col span={12}>
                <Form.Item label="Publica no E-commerce?" name="publicaEcommerce">
                    <Select data-tab={dataTab} >
                        <Option value={1}>SIM</Option>
                        <Option value={0}>NAO</Option>
                    </Select>
                </Form.Item>
            </Col>
            <Col span={12}>
                <Form.Item  label="Estoque do e-commerce" name="estoqueEcommerce">
                    <Select data-tab={dataTab}>
                        <Option value={"EM_ESTOQUE"}>Em estoque</Option>
                        <Option value={"FORA_ESTOQUE"}>Fora de Estoque</Option>
                    </Select>
                </Form.Item>
            </Col>
            <Col sm={8}>
                <Form.Item label="Peso" name="peso">
                    <InputNumero data-tab={dataTab} />
                </Form.Item>
            </Col>
            <Col sm={8}>
                <Form.Item label={`Para cada ${dadosProduto.uCom} eu tenho`} name="fatorCorrecaoUnidadeEcommerce">
                    <InputNumero data-tab={dataTab} addonAfter={"UN no E-commerce"} onBlur={changeFatorCorrecaoUnidadeEcommerceHandler} />
                </Form.Item>
            </Col>
            <Col sm={8}>
                <Form.Item label="Valor de Venda no E-commerce" name="precoEcommerce">
                    <InputNumero data-tab={dataTab} />
                </Form.Item>
            </Col>
            
            <Col sm={12}>
                <Form.Item label="Descrição Curta" name="descricaoCurta">
                    <TextArea data-tab={dataTab} rows={5} />
                </Form.Item>
            </Col>
            <Col sm={12}>
                <Form.Item label="Descricao Longa" name="descricaoLonga">
                    <TextArea data-tab={dataTab} rows={5} />
                </Form.Item>
            </Col>
            
        </Row>
    );
}

export {TabECommerce};